import React from 'react'
import { useAppContext } from '../../../context/appContext';
import { TextMd, TextSm } from '../../../components/text';
import { SeeMore } from '../../home/components/seeMore';

export const InteractiveDashboards = ({ className="" }) => {
  const { routing } = useAppContext();
  const { navigate } = routing;

  return (
    <button
      className={`flex w-full flex-col items-center gap-8 text-left ${className}`}
      onClick={()=>{
        navigate((prev)=> `${prev}/dashboard`);
      }}
    >
      <div className="w-full flex flex-col">
        <TextSm className="uppercase whitespace-nowrap tracking-[0.1em] text-blue-500 font-semibold">
          Interactive Dashboards
        </TextSm>

        <TextMd className="font-semibold text-slate-900 mb-4">
          Visualizing performance in real time.
        </TextMd>

        <TextSm className="text-slate-500 leading-7 mb-8">
          Custom dashboards transform complex data into intuitive
          visualizations, helping teams monitor performance, identify trends,
          and make informed decisions without digging through spreadsheets.
        </TextSm>

        <div className="flex flex-wrap gap-x-8 gap-y-3">
          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Real-Time KPI Tracking</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Custom Visualizations</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Centralized Data Sources</TextSm>
          </div>
        </div>
      </div>
      
      <SeeMore text="See Example" />
      
    </button>
  )
}
